<template>
  <div class="content">
    <card title="发电机组">
      <div class="card_content">
        <div class="item_list fb">
          <div class="item box_style fs" v-for="(item, index) in machineListData" :key="index">
            <div class="icon">
              <img :src="`${require(`@/assets/hs/${item.icon}.png`)}`" alt="" class="Img" />
            </div>
            <div class="info">
              <p class="value light" v-if="item.code == 'state'">
                {{ item.value ? '启动' : '待机' }}
              </p>
              <p class="value light" v-else>{{ item.value | FormatNumber }}</p>
              <p class="name">{{ item.name }}</p>
            </div>
          </div>
        </div>
        <div class="card_chart box_style">
          <div class="temp_progress fr" v-for="(item, index) in temp_list" :key="index">
            <p class="name">{{ item.name }}</p>
            <div class="progress_bar">
              <div class="progress" :style="`width:${item.value}%`"></div>
            </div>
            <p class="value light">{{ item.value }}°c</p>
          </div>
        </div>
      </div>
    </card>
    <card title="机组拆解图" styles="margin-top:24px">
      <div class="card_chaijie box_style">
        <div class="view_box">
          <img :src="`${require(`@/assets/hs/bg_chaijie.png`)}`" class="Img" alt="" />
        </div>
        <div class="btn_box fb">
          <div class="btn" @click="handleClickDevice('03')">拆解</div>
          <div class="btn" @click="handleClickDevice('04')">组装</div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
export default {
  name: 'FaDianJiZu',
  components: {
    Card,
  },
  data() {
    return {
      machineListData: [
        { code: 'state', name: '机组状态', icon: 'icon_1_1', value: '正常' },
        { code: 'activePower', name: '有功功率', icon: 'icon_1_2', value: '0.0' },
        { code: 'reactivePower', name: '无功功率', icon: 'icon_1_3', value: '0.1' },
        { code: 'frequency', name: '机组频率', icon: 'icon_1_4', value: '19.9' },
        { code: 'guideOpen', name: '导叶开度', icon: 'icon_1_5', value: '19.7' },
        { code: 'statorVoltage', name: '定子电压', icon: 'icon_1_6', value: '20.8' },
      ],
      temp_list: [
        { code: '', name: '定子温度1', value: '22.1' },
        { code: '', name: '定子温度2', value: '22.1' },
        { code: '', name: '定子温度3', value: '21.7' },
        { code: '', name: '定子温度4', value: '22.4' },
        { code: '', name: '定子温度5', value: '22.1' },
      ],
      curClickType: '',
      curClickState: '',
      RealDataEleMachine: {}, //发电机组实时数据
    };
  },
  mounted() {
    this.stationInfo = this.$Storage.get('stationInfo');
    this.RealDataEleMachine = this.stationInfo.deviceList[0].hydropowerPumpRealVo;
    this.renderData();
  },
  methods: {
    handleClickDevice(type) {
      if (this.curClickType == type && this.curClickState == 'play') {
        this.curClickState = 'stop';

        this.$Model.i3dAnimate(type, 'stop');
      } else {
        this.curClickState = 'play';
        this.curClickType = type;
        this.$Model.i3dAnimate(type, 'play');
      }
    },
    renderData() {
      this.machineListData.forEach((item, index) => {
        this.$set(this.machineListData[index], 'value', this.RealDataEleMachine[item.code]);
        console.log('this.machineListData[value]', this.machineListData);
        this.$forceUpdate();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card_content {
  .item_list {
    flex-wrap: wrap;
    .item {
      flex: 0 0 auto;
      width: 152px;
      height: 80px;
      margin-bottom: 12px;
      .icon {
        width: 48px;
        height: 48px;
        margin-left: 10px;
        margin-right: 10px;
      }
      .info {
        .value {
          font-size: 20px;
        }
      }
    }
  }

  .card_chart {
    width: 480px;
    height: 153px;
    padding: 10px;
    .temp_progress {
      margin-bottom: 7px;
      p.name {
      }
      p.value {
        font-size: 16px;
      }
      .progress_bar {
        width: 300px;
        height: 6px;
        background: rgba(10, 72, 126, 0.45);
        border-radius: 7px;
        .progress {
          width: 155px;
          height: 6px;
          background: linear-gradient(90deg, #ffa182 0%, #fe4443 100%);
          border-radius: 7px;
        }
      }
    }
  }
}
</style>
